import { InvoicePeriodType, PlanType, SubscriptionModel } from '@app/reducers/account/account-subscription.model';

export {
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  SubscriptionModel,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  PlanModel,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  PlanType,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  PlanQuotaModel,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  QuotaType,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  SubscriptionCheckType,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.model` instead or use selectors */
  InvoicePeriodType,
} from '@app/reducers/account/account-subscription.model';

export {
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.helper` instead or use selectors */
  PlanTypeWeight,
  /** @deprecated Import directily from `@app/reducers/account/account-subscription.helper` instead or use selectors */
  UNLIMITED_QUOTA,
} from '@app/reducers/account/account-subscription.helper';

export const transformedPlanTypeLabels = {
  [PlanType.FREE]: 'Free',
  [PlanType.BASIC]: 'Basic',
  //Techdept an entry for starter had to be maintained for backwards compatabillity issues
  //Remove with tmp_rename_starter_to_basic (SHB-8838)
  [PlanType.STARTER]: 'Basic',
  [PlanType.EARLY_ADOPTER]: 'Early Adopter',
  [PlanType.PREMIUM]: 'Premium',
  [PlanType.ENTERPRISE]: 'Enterprise',
};

export interface SelectedSubscriptionModel {
  subscription: SubscriptionModel;
  integrationPlus?: boolean;
  invoicePeriod: InvoicePeriodType;
}

export enum PaymentMethodType {
  NONE = 'No payment details',
  CREDIT_CARD = 'Credit card',
  DEBIT = 'Automatic debit',
  TRANSFER = 'Transfer',
}

export interface SubscriptionEstimatesModel {
  unit_amount: number;
  quantity: number;
  next_billing_date: string;
  sub_total: number;
  total: number;
  taxes: EstimateTaxModel[];
  tax_amount: number;
  currency: string;
  line_items: EstimateItemModel[];
  currency_symbol: string;
}

export interface EstimateTaxModel {
  object: string;
  name: string;
  description: string;
  amount: number;
}

export interface EstimateItemModel {
  entity_type: string;
  description: string;
  quantity: number;
  unit_amount: number;
  amount: number;
  discount_amount: number;
}
